export default __webpack_public_path__ + "static/media/logo_escrow.f163ebbe.svg";